module.exports = __webpack_public_path__ + "genomed_sa_02.jpg?f0307c7d8eabf173779fb209992991af";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/genomed_sa_02.jpg
// module id = 142
// module chunks = 0